import React, { useEffect } from 'react';

import { useField, ErrorMessage } from 'formik';
import FormFieldError from 'app/components/common/FormFieldError';
import SelectBox from 'app/components/common/SelectBox';

export interface IFormFieldSelectOption {
  name: string;
  value: string;
  image?: string;
}

interface IFormFieldSelectProps {
  name: string;
  label?: string;
  value?: string | string[];
  required?: boolean;
  placeholder?: string;
  multiple?: boolean;
  showSelectedOptions?: boolean;
  showSelectedOptionCount?: boolean;
  onChange?(option: IFormFieldSelectOption | IFormFieldSelectOption[]): void;
  options: IFormFieldSelectOption[];
}

export default function FormFieldSelect({
  name,
  label,
  value,
  required,
  placeholder,
  multiple = false,
  showSelectedOptions = true,
  showSelectedOptionCount = false,
  onChange,
  options
}: IFormFieldSelectProps) {
  const [field, meta, helpers] = useField({ name, value });

  function handleChange(
    option: IFormFieldSelectOption | IFormFieldSelectOption[]
  ) {
    if (Array.isArray(option)) {
      helpers.setValue(option.map(el => el.value));
    } else {
      helpers.setValue(option.value);
    }
    typeof onChange === 'function' && onChange(option);
  }

  return (
    <div className="relative flex flex-col gap-1">
      <SelectBox
        options={options}
        value={field.value}
        label={label}
        required={required}
        placeholder={placeholder || name}
        onChange={handleChange}
        multiple={multiple}
        showSelectedOptions={showSelectedOptions}
        showSelectedOptionCount={showSelectedOptionCount}
      />
      <ErrorMessage
        component={() => <FormFieldError message={meta.error} />}
        name={name}
      />
    </div>
  );
}
